/**
 * localStorage 核心库 LS
 */

function LS(prefix, separator){
    this.prefix = prefix || '__SEC__LS__'; //key前辍
    this.separator = separator || '|-|'; //分隔符
}

LS.prototype = {
    constructor: LS,
    storage: localStorage || window.localStorage,
    status: {
        SUCCESS : {
            no: 0,
            msg: '成功'
        }, //成功
        FAILURE : {
            no: 1,
            msg: '失败'
        }, //失败
        OVERFLOW: {
            no: 2,
            msg: '溢出'
        }, //溢出
        TIMEOUT : {
            no: 3,
            msg: '过期'
        } //过期
    },
    getKey: function(key){
        return this.prefix + key;
    },
    get: function(key, callback){
        var storage = this.storage,
            status = this.status;

        try{
            var SUCCESS = status.SUCCESS,
                TIMEOUT = status.TIMEOUT,
                value = storage.getItem(this.getKey(key)),
                arr = value.split(this.separator),
                val = arr[0],
                time = parseInt(arr[1]);

            if(time > Date.now() || time === 0){ //未过期
                return {
                    errno: SUCCESS.no,
                    errmsg: SUCCESS.msg,
                    data: val //存在，则返回其值；否则返回null
                }
            }else{ //过期
                val = null;
                this.remove(key);
                return {
                    errno: TIMEOUT.no,
                    errmsg: TIMEOUT.msg,
                    data: null //存在，则返回其值；否则返回null
                }
            }
        }catch(e){
            var FAILURE = this.status.FAILURE;
            return {
                errno: FAILURE.no,
                errmsg: FAILURE.msg,
                data: null
            };
        }
    },
    set: function(key, value, time, calllback){
        var storage = this.storage,
            status = this.status,
            key = this.getKey(key);

        //计算有效时间， 默认为31天; 0表示永久有效
        try{
            time = time === 0 ? 0 : (new Date(time).getTime() || time.getTime());
        }catch(e){
            time = Date.now() + 1000 * 60  * 60 * 24 * 31; //31天
        }

        try{
            var SUCCESS = status.SUCCESS;
            storage.setItem(key, value + this.separator + time);
            return {
                errno: SUCCESS.no,
                errms: SUCCESS.msg,
            };
        }catch(e){
            var OVERFLOW = status.OVERFLOW;
            return {
                errno: OVERFLOW.no,
                errmsg: OVERFLOW.msg
            }
        }
    },
    remove: function(key, callback){
        var storage = this.storage;

        if(this.get(key).errno !== 0) return;

        try{
            var SUCCESS = this.status.SUCCESS;
            storage.removeItem(this.getKey(key));
            return {
                errno: SUCCESS.no,
                errmsg: SUCCESS.msg
            };
        }catch(e){
            var FAILURE = this.status.FAILURE;
            return {
                errno: FAILURE.no,
                errmsg: FAILURE.msg
            }
        }
    }
}

export default LS;



//////////////////
// WEBPACK FOOTER
// ../common/js/utils/baseLocalStorage.js
// module id = null
// module chunks = 